import RouterLink from '@app/components/RouterLink';
import DevText from '@app/components/Text';
import { Colors } from '@blueprintjs/core';
import React from 'react';
import {
    NotificationResource,
    SubscriptionResource,
} from 'dy-frontend-http-repository/lib/modules/Notification/resources';
import { Endpoints } from '@app/data/consts';
import NotificationTemplate from '../../../../NotificationTemplate';

export interface SubscriptionAutoRenewEnabledNotificationProps {
    authorizedUserId: ID;
    notification: NotificationResource;
    subscription: SubscriptionResource | null;
    dismiss: () => Promise<void>;
}

type Props = SubscriptionAutoRenewEnabledNotificationProps;

const SubscriptionAutoRenewEnabledNotification: React.FC<Props> = ({ notification, subscription, dismiss }) => {
    const renderContent = () => {
        if (!subscription) {
            // This is bad, subscription is NOT found, which should not happen
            return <DevText color={Colors.RED2}>Subscription was not found</DevText>;
        }

        return (
            <div>
                <DevText running>
                    <RouterLink to={Endpoints.SUBSCRIPTION.replace(':subscriptionId', subscription.id)}>
                        Subscription
                    </RouterLink>{' '}
                    of{' '}
                    <RouterLink to={Endpoints.CLIENT_BILLING.replace(':clientId', subscription.user.id)}>
                        {subscription.user.first_name} {subscription.user.last_name}
                    </RouterLink>{' '}
                    won't be cancelled on the end of its current period
                </DevText>
            </div>
        );
    };

    return (
        <NotificationTemplate
            title="Subscription cancellation prevented"
            icon="play"
            at={notification.activity.at}
            content={renderContent()}
            dismiss={dismiss}
        />
    );
};

export default SubscriptionAutoRenewEnabledNotification;
